const scope = 'App/';
export const REDIRECT = `${scope}REDIRECT`;
